import * as React from "react"
import Layout from "../Components/Layout";
import map from "./../images/map.jpg";

export default function Location() {
  return (
    <main>
      <title>Locatie - Fietsen Marijnissen :: Koop een fiets bij de man die hem ook vakkundig herstellen kan!</title>
      <Layout>
        <h1>Locatie</h1>
        <p>Bredabaan 878<br />
        2930 Brasschaat<br />
        Maria-Ter-Heide<br />
        <img src={map} alt="Map" />
        </p>
      </Layout>
    </main>
  );
}

